import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/core/services/common.service';
import { NotifierService } from 'angular-notifier';
import { BaseComponent } from 'src/app/shared/components/base/base.component';

import { animate, state, style, transition, trigger } from '@angular/animations';

import { Message } from 'src/app/core/class/message';

@Component({
  selector: 'app-document-mangement',
  templateUrl: './document-management.component.html',
  styleUrls: ['./document-management.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('void', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('*', style({ height: '*', visibility: 'visible' })),
      transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class DocumentManagementComponent extends BaseComponent implements OnInit {

  constructor(
    public commonService: CommonService,
    public message: Message,
    private notifier: NotifierService
  ) {
    super(commonService, message);
    this.notifier = notifier;
  }

  ngOnInit() {
  }

}
